import { Box, Stack, Typography, styled, lighten } from "@mui/material";
import { ReactNode } from "react";
import { FONT_COLORS, BG_COLORS } from "../../constants";

interface ITabOption<T extends string> {
  value: T;
  label: string | ReactNode;
}

interface ITabSwitchProps<T extends string> {
  options: ITabOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

const TabContainer = styled(Box)(() => ({
  display: "inline-flex",
  borderRadius: "4px",
  padding: "3px",
  backgroundColor: "#F5F5F5",
  width: "auto",
}));

const TabItem = styled(Box)<{ selected: boolean }>(({ selected }) => ({
  padding: "6px 32px",
  borderRadius: "3px",
  cursor: "pointer",
  backgroundColor: selected ? BG_COLORS.default : "transparent",
  transition: "all 0.3s ease",
  boxShadow: selected ? "0 5px 10px rgba(0, 0, 0, 0.075)" : "none",
}));

export const TabSwitch = <T extends string>({
  options,
  value,
  onChange,
}: ITabSwitchProps<T>) => {
  return (
    <TabContainer>
      <Stack direction="row" width="100%">
        {options.map((option) => (
          <TabItem
            key={option.value}
            selected={value === option.value}
            onClick={() => onChange(option.value)}
            sx={{
              display: "flex",
              flex: "auto",
              justifyContent: "center",
            }}
          >
            <Typography
              fontSize={14}
              fontWeight={600}
              color={
                value === option.value
                  ? FONT_COLORS.default
                  : lighten(FONT_COLORS.default, 0.6)
              }
            >
              {option.label}
            </Typography>
          </TabItem>
        ))}
      </Stack>
    </TabContainer>
  );
};

export default TabSwitch;
